<template>
    <v-sheet rounded class="v-sheet--offset d-flex align-center justify-center" elevation="5" :height="isMobile ? 60 : 80" :width="isMobile ? 130 : 250">
        <v-icon color='#4ec5c1' :x-large='!isMobile'>{{icon}}</v-icon> <span> <span v-if="!isMobile" class="ml-2"> {{text}} {{text2}}: </span> <span v-if="!loading" class="ml-2"> {{showedData || 0}}</span> </span>
    </v-sheet>
</template>

<script>
	
export default {
    name: 'OneDataCardPlus',
    props: [ 'icon', 'showedData', 'text', 'text2', 'loading' ],
    
};
    
</script>


